"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = require("react");
const react_flow_renderer_1 = __importStar(require("react-flow-renderer"));
require("react-flow-renderer/dist/style.css");
const CustomNode_1 = __importDefault(require("../customNode/CustomNode"));
const team_management_pathway_svg_1 = __importDefault(require("../../../assets/images/pathways/team-management-pathway.svg"));
const business_leadership_pathway_svg_1 = __importDefault(require("../../../assets/images/pathways/business-leadership-pathway.svg"));
const management_accelerator_pathway_svg_1 = __importDefault(require("../../../assets/images/pathways/management-accelerator-pathway.svg"));
const CircleDotNode_1 = __importDefault(require("../circleDotNode/CircleDotNode"));
require("./pathwayFlow.scss");
const FlowRightInfoContainer_1 = __importDefault(require("../flowRightInfoContainer/FlowRightInfoContainer"));
const pathwayFlowTranslations_json_1 = __importDefault(require("./pathwayFlowTranslations/pathwayFlowTranslations.json"));
const PathwayMobileBottomSheet_1 = __importDefault(require("../pathwayMobileBottomSheet/PathwayMobileBottomSheet"));
const initialNodes = [
    {
        id: "31",
        type: "circleDotNode",
        data: {},
        position: { x: 300, y: 0 },
    },
];
const initialEdges = [
    { id: "e1-3", source: "1", target: "31", type: "step" },
    {
        id: "e4-3",
        source: "4",
        target: "31",
        type: "step",
        targetHandle: "bottom-handle",
    },
    { id: "e3-2", source: "31", target: "2", type: "step" },
];
const defaultEdgeOptions = {
    animated: true,
};
const nodeTypes = {
    textUpdater: CustomNode_1.default,
    circleDotNode: CircleDotNode_1.default,
};
function PathwayFlow(props) {
    props.addTranslation(pathwayFlowTranslations_json_1.default);
    const [selectedNode, setSelectedNode] = (0, react_2.useState)(null);
    const [nodes, setNodes] = (0, react_2.useState)(initialNodes);
    const [edges, setEdges] = (0, react_2.useState)(initialEdges);
    (0, react_1.useEffect)(() => {
        updateNodes();
    }, [props.pathway, props.translate, props.addTranslation]);
    const dummyImages = [
        team_management_pathway_svg_1.default,
        business_leadership_pathway_svg_1.default,
        management_accelerator_pathway_svg_1.default,
    ];
    function updateNodes() {
        const circleNodeId = "31";
        console.log("updateNodes init", props.pathway);
        const newNodes = props.pathway.campaigns.map((campaign, index) => {
            var _a;
            // FOR PREREQUISITES TESTING
            // const dummyAutomationRules: IPathwayAutomationRules = {
            //   or: [
            //     {
            //       or: null,
            //       and: [
            //         {
            //           or: null,
            //           and: null,
            //           campaign: {
            //             id: "08dd808d-fd36-40bb-8534-37cb224877c5",
            //             title: "Credential 1",
            //             description: null,
            //             status: 1,
            //             design: null,
            //             badgeDesign: null,
            //             recipientCount: 0,
            //             recipientGroupId: "08dd808d-fd34-4e37-89a9-051578441fff",
            //             automationReady: false,
            //           },
            //         },
            //         {
            //           or: null,
            //           and: null,
            //           campaign: {
            //             id: "08dd808d-fd36-40bb-8534-37cb224877c5",
            //             title: "Credential 3",
            //             description: null,
            //             status: 1,
            //             design: null,
            //             badgeDesign: null,
            //             recipientCount: 0,
            //             recipientGroupId: "08dd808d-fd34-4e37-89a9-051578441fff",
            //             automationReady: false,
            //           },
            //         },
            //       ],
            //       campaign: null,
            //     },
            //     {
            //       or: null,
            //       and: [
            //         {
            //           or: null,
            //           and: null,
            //           campaign: {
            //             id: "08dd808d-fd36-40bb-8534-37cb224877c5",
            //             title: "Credential 7",
            //             description: null,
            //             status: 1,
            //             design: null,
            //             badgeDesign: null,
            //             recipientCount: 0,
            //             recipientGroupId: "08dd808d-fd34-4e37-89a9-051578441fff",
            //             automationReady: false,
            //           },
            //         },
            //         {
            //           or: null,
            //           and: null,
            //           campaign: {
            //             id: "08dd808d-fd36-40bb-8534-37cb224877c5",
            //             title: "Credential 5",
            //             description: null,
            //             status: 1,
            //             design: null,
            //             badgeDesign: null,
            //             recipientCount: 0,
            //             recipientGroupId: "08dd808d-fd34-4e37-89a9-051578441fff",
            //             automationReady: false,
            //           },
            //         },
            //       ],
            //       campaign: null,
            //     },
            //   ],
            // };
            // campaign.automationRules = dummyAutomationRules;
            return {
                id: campaign.id,
                type: "textUpdater",
                data: Object.assign(Object.assign({}, campaign), { recipientText: props.translate("recipientReceived", {
                        recipientCount: ((_a = campaign.campaign) === null || _a === void 0 ? void 0 : _a.recipientCount) || 0,
                    }) }),
                position: {
                    x: (campaign.xPosition - 1) * 500,
                    y: (campaign.yPosition - 1) * 400,
                },
            };
        });
        const medianX = newNodes.reduce((acc, node) => acc + node.position.x, 0) /
            newNodes.length;
        const circleNode = {
            id: "31",
            type: "circleDotNode",
            data: {},
            position: { x: medianX, y: -200 },
        };
        console.log("newNodes", newNodes);
        setNodes([...newNodes, circleNode]);
        updateEdges();
    }
    function updateEdges() {
        const circleNodeId = "31";
        const newEdges = props.pathway.campaigns.map((campaign) => {
            return {
                id: `e${campaign.id}-${circleNodeId}`,
                source: campaign.id,
                target: circleNodeId,
                type: "step",
            };
        });
        console.log("newEdges", newEdges);
        setEdges(newEdges);
    }
    const onNodesChange = (0, react_2.useCallback)((changes) => setNodes((nds) => (0, react_flow_renderer_1.applyNodeChanges)(changes, nds)), [setNodes]);
    const onEdgesChange = (0, react_2.useCallback)((changes) => setEdges((eds) => (0, react_flow_renderer_1.applyEdgeChanges)(changes, eds)), [setEdges]);
    const onConnect = (0, react_2.useCallback)((connection) => setEdges((eds) => (0, react_flow_renderer_1.addEdge)(connection, eds)), [setEdges]);
    const onNodeClick = (0, react_2.useCallback)((event, node) => {
        const campaignByNodeId = props.pathway.campaigns.find((campaign) => campaign.id === node.id);
        if (campaignByNodeId) {
            setSelectedNode(campaignByNodeId);
        }
    }, []);
    const onPaneClick = (0, react_2.useCallback)(() => {
        setSelectedNode(null);
    }, []);
    return (react_1.default.createElement("div", { className: `pathway-flow-wrapper ${props.isMobile ? "mobile" : ""}` },
        react_1.default.createElement(react_flow_renderer_1.default, { nodes: nodes, style: {
                height: "500px",
                borderRadius: "8px",
                background: "#F7F7F7",
                maxWidth: props.isMobile ? "100%" : "1180px",
                width: "100%",
            }, nodeTypes: nodeTypes, edges: edges, onNodesChange: onNodesChange, onEdgesChange: onEdgesChange, onConnect: onConnect, fitView: true, defaultEdgeOptions: defaultEdgeOptions, onNodeClick: onNodeClick, onPaneClick: onPaneClick }),
        !props.isMobile ? (react_1.default.createElement(FlowRightInfoContainer_1.default, Object.assign({}, props, { infoNode: selectedNode ? selectedNode : props.pathway }))) : (react_1.default.createElement(PathwayMobileBottomSheet_1.default, Object.assign({}, props, { infoNode: selectedNode ? selectedNode : props.pathway })))));
}
exports.default = PathwayFlow;
